import {
  Step,
  StepLabel,
  Stepper,
  useMediaQuery,
  useTheme,
} from '@material-ui/core'
import { useBreadcrumbs } from 'baby-ui/hooks'
import { PATIENT_TO_CHECKOUT_PATH } from '../../constants'
import { breadcrumbsDisplayNameMap } from '../../shared'

export interface CheckoutJourneyStepsWidgetProps {
  currentPath: string
}

const CheckoutJourneyStepsWidget = ({
  currentPath,
}: CheckoutJourneyStepsWidgetProps) => {
  const theme = useTheme()
  const isMobilePortrait = useMediaQuery(theme.breakpoints.down('xs'))

  const breadcrumbs = useBreadcrumbs(
    PATIENT_TO_CHECKOUT_PATH,
    breadcrumbsDisplayNameMap,
    { currentPath }
  )

  return (
    <Stepper alternativeLabel={isMobilePortrait}>
      {breadcrumbs.map((breadcrumb) => (
        <Step
          active={breadcrumb.current}
          completed={breadcrumb.visited}
          key={breadcrumb.path}
        >
          <StepLabel
            style={{ textAlign: isMobilePortrait ? 'center' : undefined }}
          >
            {breadcrumb.name}
          </StepLabel>
        </Step>
      ))}
    </Stepper>
  )
}

export default CheckoutJourneyStepsWidget
